import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './banner-jss';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete'
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import AddBanner from '../../New/Banner/AddBanner';
import ConfirmDialog from '../../Dialog/ConfirmDialog';
import Snackbar from '@material-ui/core/Snackbar';
import CustomNotification from '../../Notification/CustomNotification';
import { fetchCall } from '../../../service/service_base';
import { savePortrait } from '../../../service/s3Amplify';
import ls from 'local-storage';
import { S3Image } from 'aws-amplify-react';
class Banner extends React.Component {
  state = {
    openAddBanner: false,
    action: "Nuevo",
    banner: []
  }

  componentDidMount() {
    this._loadNotes();
  }

  _loadNotes = () => {
    fetchCall("POST", "/synthesis/getcontent", {
      sectionId: this.props.section.sec_id,
      isPublish: this.props.isPublish,
      idPublish: this.props.idPublish
    }).then(response => {
      this.setState({ banner: response.data, isLoading: false, });

    }).catch(err => console.log(err));
  }
  handleCloseNotification = () => {
    this.setState({
      openNotification: false
    })
  }
  openAddBanner = () => {
    this.setState({
      openAddBanner: true,
      action: "Nuevo",
      noteSelected: null
    })
  }

  _handleCloseAddBanner = () => {
    this.setState({
      openAddBanner: false,
      action: "Nuevo",
      noteSelected: null
    })
  }

  _handleAddBanner = (event, data, file) => {
    event.preventDefault();
    this.setState({ isLoading: true });
    if (data.title.toString().trim() === '') {
      this.setState({
        openNotification: true,
        messageNotification: 'Debes agregar un Link',
        typeNotification: "warning",
        isLoading: false
      });
      return false;
    }

    data.imagePath = '';
    data.sectionId = this.props.section.sec_id;
    data.userId = ls.get("current_user").user_id;
    let keyS3 = `${this.props.synthesis}/${this.props.section.sec_id}/${file ? `${new Date().getTime()+"_" + file.name}`.replace(/[^0-9A-Z._]+/gi,"-") : ''}`;

    if (data.isUpdating) {
      Promise.all([(file ? savePortrait(keyS3, file, file.type) : null)])
        .then(response => {
          data.imagePath = response[0] !== null ? response[0].key : this.state.noteSelected.cont_imagePath;
          fetchCall("POST", "/synthesis/updatecontent", data).then(response => {
            if (response.status == 200) {
              this.setState({
                openNotification: true,
                messageNotification: 'Contenido actualizado',
                typeNotification: "success",
                isLoading: false,
                noteSelected: null,
                openAddBanner: false,
              });
              this._handleCloseAddBanner()
            setTimeout(() => { this._loadNotes(); }, 1500);
            }
          }).catch(err => err);
        })
    } else {
      data.idPublish = this.props.idPublish
      data.order = this.state.banner.length + 1
      Promise.all([savePortrait(keyS3, file, file.type)])
        .then(response => {
          data.imagePath = response[0].key;
          fetchCall("POST", "/synthesis/addcontent", data).then(response => {
            this.setState({
              openNotification: true,
              messageNotification: 'Contenido guardado',
              typeNotification: "success",
              noteSelected: null
            });
            this._handleCloseAddBanner()
            setTimeout(() => { this._loadNotes(); }, 1500);
          }).catch(err => err);
        })
    }
  }

  openConfirmDelete = (item) => {
    this.setState({
      openConfirmDialog: true,
      idDeleted: item
    })
  }
  edit = (item) => {
    this.setState({
      openAddBanner: false,
      noteSelected: null
    }, () => {
      this.setState(
        {
          openAddBanner: true,
          noteSelected: item,
          action: "Editar"
        }
      )
    })
  }

  remove = () => {
    this.setState({ isLoading: true });
    fetchCall("POST", "/synthesis/removecontentsection", {
      contId: this.state.idDeleted.cont_id,
      userId: ls.get("current_user").user_id
    }).then(response => {
      if (response.status == 200) {
        // apiElasticSearch("/doc/upsert-doc", { dataElastic: [{cont_id:this.state.idDeleted.cont_id}],deleteDoc:true})
        // deleteS3Object(this.state.idDeleted.cont_key)
        this.setState({
          openConfirmDialog: false,
          isLoading: false,
          openNotification: true,
          messageNotification: 'Contenido eliminado',
          typeNotification: "success"
        });
         this._loadNotes(); 
      }
    }).catch(err => console.log(err));
  }

  _closeConfirmDialog = () => {
    this.setState({
      openConfirmDialog: false,
      idDeleted: null
    })
  }
  
  render() {
    const {
      classes,
      canDelete,
      canEdit,
      section
    } = this.props;
    return (
      <div className="container">
        <AddBanner
          classes={classes}
          submit={this._handleAddBanner}
          openForm={this.state.openAddBanner}
          closeForm={this._handleCloseAddBanner}
          dataInit={this.state.openAddBanner ? this.state.noteSelected : null}
          action={this.state.action}
        />

        <ConfirmDialog
          title={"¿Desea eliminar el contenido?"}
          message={"El contenido al ser eliminado no podrá recuperarse"}
          textAccept={"Aceptar"}
          textCancel={"Cancelar"}
          funcAccept={this.remove}
          funcCancel={this._closeConfirmDialog}
          open={this.state.openConfirmDialog}
        />
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.state.openNotification}
          autoHideDuration={6000}
          onClose={this.handleCloseNotification}>
          <CustomNotification
            onClose={this.handleCloseNotification}
            variant={this.state.typeNotification}
            message={this.state.messageNotification} />
        </Snackbar>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <Grid container spacing={16} justify="center">
              <Grid item> </Grid>
              {
                this.state.banner.length>0 ?
                  this.state.banner.map((item, key) => {
                    item.cont_imagePath = item.cont_key
                    return <Grid item key={key}>
                        <div className={classes.btn}>
                          <a target="_blank" href={item.cont_name} ><S3Image imgKey={item.cont_imagePath} /> </a>
                        </div>
                        <div className={classes.adminActions}>
                          <Tooltip title="Editar">
                            <Button variant="fab" mini disabled={!canEdit} aria-label="add" className={classes.button} onClick={() => this.edit(item)}>
                              <Edit />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Eliminar">
                            <Button variant="fab" mini disabled={!canDelete} aria-label="add" className={classes.button} onClick={() => this.openConfirmDelete(item)}>
                              <Delete />
                            </Button>
                          </Tooltip>
                        </div>
                      
                    </Grid>
                  })
                  :
                  <Grid item xs={12} md={6} lg={4}>
                    <div className={classes.bannerNew}>
                      <div className={classes.contentBtnNew}>
                        <Tooltip title="Nuevo banner">
                          <Button variant="fab" onClick={this.openAddBanner} mini aria-label="add" className={classes.btnNew} disabled={!canEdit}>
                            <AddIcon />
                          </Button>
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
              }
              <Grid item> </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}


export default withStyles(styles)(Banner);
